<template>
  <div id="app">
<div align="center" style="font-size: 40px;letter-spacing:4px;margin-bottom: 20px;">崇礼区人民政府办公室文件传阅追溯系统</div>
      <dv-decoration-2 style="width:100%;height:5px;" />

        <dv-scroll-board :config="config" style="width:100%;height:880px;margin-top: 10px;margin-bottom: 10px;" />

      <dv-decoration-2 style="width:100%;height:5px;" :color="['red', 'green']"/>



  </div>
</template>

<script>
export default {
  data () {
    return {
      config: {
        header:'',
        data:'',
        title: "文件传阅", //轮播列表标题

      }
    }
  },
  mounted() {
    this.$axios({
        url:'sys/filecirculate/br',
        method:'post',
        //发送格式为json
        data:''
    })
        .then(response => {
          this.config = { data:response.data.result.list}
          this.config.header=response.data.result.header;
          this.config.rowNum=30; // 表行数
          this.config.columnWidth=[650,120,120,120,120,120,120,120,120,120];
          this.config.align=['left','left','left','left','left','left','left','left','left','left'];
          this.config.waitTime=3000;
          this.config.oddRowBGC='#E3E3E3';
          this.config.evenRowBGC='#E0E0E0';
          this.config.headerHeight=45;
   

        })
  }
}
</script>

<style>
#app {
  font-family:  Arial, sans-serif;
  font-weight: bold;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

</style>
